import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const OpenEditorBtnWidgetV2: WidgetRegistryEntry = {
  name: "OpenEditorBtnV2",
  component: () => import("./open-editor-btn-widget-v2.component").then((m) => m.OpenEditorBtnWidgetV2Component),
  configuration: () => import("./configuration").then((m) => m.OpenEditorBtnWidgetV2Configuration)
};
